import React, {useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import {Container, Paper, TextField} from "@mui/material";
import StoricoCard from "./StoricoCard";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import {ContattaciStyle} from "../../../../styles/pages/contact/ContattaciStyle";
import clsx from "clsx";
import HideAppBar from "../../../widgets/header/HideAppBar";

const AllTicketOperatore = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	const [value, setValue] = useState("");
	
	const handleSearch = (e) => {
		setValue(e.target.value);
	}
	
	useEffect(() => {
		document.body.style = "background: none";
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Ricerca ticket"} back={true} backPosition={"/gestione/callcenter"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper className={clsx(classes.roundBorder)} component={"section"}>
								<TextField
									placeholder={"Cerca per Codice fiscale, dettaglio richiesta, cellulare, categoria, sotto categoria"}
									value={value}
									onChange={handleSearch}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder}
									}}
								/>
							</Paper>
						</Grid>
						<Grid item xs={12}>
							<StoricoCard showButton={false} useSearch={true}
							             subheader={"Qui trovi tutti i ticket da cercati"} value={value}/>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
};

export default React.memo(AllTicketOperatore);
